import React from 'react';

import { Box } from '@mui/material';
import cx from 'classnames';

import useStyles from './styles';

interface CardInfoProps {
  className?: string;
}

const CardInfo: React.FC<CardInfoProps> = ({ className, children }) => {
  const classes = useStyles();

  return <Box className={cx(classes.wrapper, className)}>{children}</Box>;
};

export default CardInfo;
